import { FC, useEffect, useState } from 'react';

import { useRecoilState } from 'recoil';

import { saleCaseLayoutState } from '@recoil_iqfu/atoms/public/saleCaseLayout';

import styles from './SaleCaseLayoutSelector.module.scss';

const SaleCaseLayoutSelector: FC = ({ children }) => {
  const [saleCaseLayout, setSaleCaseLayout] = useRecoilState(saleCaseLayoutState);
  //reocoil perist table時レンダリングバグるのでmount後に表示
  const [layoutLoaded, setIsLayoutLoaded] = useState(false);

  useEffect(() => {
    setIsLayoutLoaded(true);
  }, []);

  return (
    <>
      {layoutLoaded && (
        <div className={styles.saleCase_layout_selector}>
          <span className={styles.layout_selector_text}>表示</span>
          <button
            className={`${styles.layout_selector_button} ${saleCaseLayout === 'cards' ? styles.is_active : ''}`}
            onClick={() => setSaleCaseLayout('cards')}
          >
            <img src="/images/iqfu/public/choose_cards_layout.svg" alt="カード" />
          </button>
          <button
            className={`${styles.layout_selector_button} ${saleCaseLayout === 'table' ? styles.is_active : ''}`}
            onClick={() => setSaleCaseLayout('table')}
          >
            <img src="/images/iqfu/public/choose_table_layout.svg" alt="テーブル" />
          </button>
        </div>
      )}
    </>
  );
};

export default SaleCaseLayoutSelector;
